/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import {Component, Input} from '@angular/core';

/**
 * Generated class for the ErrorMessage component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'error-message',
  templateUrl: 'error-message.html'
})
export class ErrorMessage {

  @Input()
  message: string;

  constructor() {
    console.log('Hello ErrorMessage Component');
  }

}



// WEBPACK FOOTER //
// ./src/components/error-message/error-message.ts